import { IDatabaseService } from './IDatabaseService';
import { ElectronDatabaseAdapter } from './ElectronDatabaseAdapter';
import { WebDatabaseAdapter } from './WebDatabaseAdapter';

let databaseInstance: IDatabaseService | null = null;
let initializationPromise: Promise<IDatabaseService> | null = null;

// Platform detection
export function isElectron(): boolean {
  return typeof window !== 'undefined' && window.electronAPI !== undefined;
}

export function isPWA(): boolean {
  return !isElectron();
}

/**
 * Factory function - returns appropriate database implementation based on platform
 * Singleton pattern ensures only one database instance exists
 * Uses initialization promise to prevent race conditions
 */
export async function getDatabaseService(): Promise<IDatabaseService> {
  // If already initialized, return immediately
  if (databaseInstance) {
    return databaseInstance;
  }

  // If initialization is in progress, wait for it
  if (initializationPromise) {
    return initializationPromise;
  }

  // Start initialization
  initializationPromise = (async () => {
    let instance: IDatabaseService;

    if (isElectron()) {
      console.log('[DatabaseFactory] Using Electron database adapter');
      instance = new ElectronDatabaseAdapter();
    } else {
      console.log('[DatabaseFactory] Using Web database adapter');
      instance = new WebDatabaseAdapter();
    }

    await instance.initialize();
    databaseInstance = instance;
    return instance;
  })();

  return initializationPromise;
}

/**
 * For testing - reset singleton
 * Allows tests to create fresh database instances
 */
export function resetDatabase(): void {
  databaseInstance = null;
  initializationPromise = null;
}
